export const themes = {
  default: {
    thRoot: 'relative font-base font-bold text-center',
    thDayPicker: {
      container: 'overflow-hidden relative sm:bg-white sm:rounded', // The container element
      wrapper: '', // The wrapper element, used for keyboard interaction
      interactionDisabled: '', // Added to the container when there's no interaction with the calendar

      navBar: 'flex items-center justify-between pb-2', // The navigation bar with the arrows to switch between months
      navButtonPrev: '', // Button to switch to the previous month
      navButtonNext: '', // Button to switch to the next month
      navButtonInteractionDisabled: 'pointer-events-none cursor-default', // Added to the navbuttons when disabled with fromMonth/toMonth props

      months: 'flex -m-3', // Container of the months table
      month: 'flex-1 p-3', // The month's main table
      caption: 'font-bold mb-5 text-center text-md text-gray-darker', // The caption element, containing the current month's name and year
      weekdays: '', // Table header displaying the weekdays names
      weekdaysRow: 'flex', // Table row displaying the weekdays names
      weekday: 'flex-1 text-base text-gray-medium uppercase', // Cell displaying the weekday name
      body: 'body border-l border-b border-gray-light', // Table's body with the weeks
      week: 'flex', // Table's row for each week
      day:
        'cursor-pointer flex-1 flex flex-col items-center justify-center md:h-25 h-13 p-1 text-base text-center transition-all border-t border-r border-gray-light', // The single day cell
      footer: 'mt-3', // The calendar footer (only with todayButton prop)
      todayButton: 'text-blue focus:text-turquoise hover:text-turquoise text-sm reset-button', // The today button (only with todayButton prop)

      /* default modifiers */
      today: 'underline', // Added to the day's cell for the current day
      selected: 'bg-overlay-emerald-30 opacity-100 Datepicker-selected', // Added to the day's cell specified in the "selectedDays" prop
      disabled: 'cursor-default pointer-events-none text-gray-medium', // Added to the day's cell specified in the "disabledDays" prop
      outside: 'text-gray-light', // Added to the day's cell outside the current month
    },
    thDayStart: 'thDayStart bg-emerald-active text-white',
    thDayEnd: 'thDayEnd bg-emerald-active text-white',
    thDayMiddle: 'thDayMiddle bg-emerald text-white',
  },
  compact: {
    thRoot: 'relative font-base font-bold text-center',
    thDayPicker: {
      container: 'overflow-hidden relative sm:bg-white sm:rounded', // The container element
      wrapper: '', // The wrapper element, used for keyboard interaction
      interactionDisabled: '', // Added to the container when there's no interaction with the calendar

      navBar: 'flex items-center justify-between pb-2', // The navigation bar with the arrows to switch between months
      navButtonPrev: '', // Button to switch to the previous month
      navButtonNext: '', // Button to switch to the next month
      navButtonInteractionDisabled: 'pointer-events-none cursor-default', // Added to the navbuttons when disabled with fromMonth/toMonth props

      months: 'flex -m-3', // Container of the months table
      month: 'flex-1 p-3', // The month's main table
      caption: 'font-bold mb-5 text-center text-md text-gray-darker', // The caption element, containing the current month's name and year
      weekdays: '', // Table header displaying the weekdays names
      weekdaysRow: 'flex', // Table row displaying the weekdays names
      weekday: 'flex-1 text-base text-gray-medium uppercase', // Cell displaying the weekday name
      body: 'body', // Table's body with the weeks
      week: 'flex', // Table's row for each week
      day:
        'cursor-pointer flex-1 flex flex-col items-center justify-center h-10 p-1 text-base text-center transition-all', // The single day cell
      footer: 'mt-3', // The calendar footer (only with todayButton prop)
      todayButton: 'text-blue focus:text-turquoise hover:text-turquoise text-sm reset-button', // The today button (only with todayButton prop)

      /* default modifiers */
      today: 'underline', // Added to the day's cell for the current day
      selected: 'bg-overlay-emerald-40 opacity-100 Datepicker-selected', // Added to the day's cell specified in the "selectedDays" prop
      disabled: 'cursor-default pointer-events-none text-gray-medium', // Added to the day's cell specified in the "disabledDays" prop
      outside: 'opacity-50', // Added to the day's cell outside the current month
    },
    thDayStart: 'bg-emerald rtl:rounded-l text-white',
    thDayEnd: 'bg-emerald rtl:rounded-r text-white',
    thDayMiddle: 'bg-emerald text-white',
  },
};
